import React from 'react';
import { Link } from 'react-router-dom';
import { Bot } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>
              <Bot size={24} style={{ display: 'inline', marginRight: '0.5rem' }} />
              AI Agents Platform
            </h3>
            <p style={{ color: 'rgba(255, 255, 255, 0.8)', marginTop: '1rem' }}>
              Soluzioni AI personalizzate per centri estetici, ristoranti e studi medici.
            </p>
          </div>

          <div className="footer-section">
            <h3>Prodotto</h3>
            <Link to="/pricing">Prezzi</Link>
            <Link to="/">Funzionalità</Link>
            <Link to="/">Casi d'uso</Link>
          </div>

          <div className="footer-section">
            <h3>Supporto</h3>
            <Link to="/">Documentazione</Link>
            <Link to="/">Contattaci</Link>
            <Link to="/">FAQ</Link>
          </div>

          <div className="footer-section">
            <h3>Legale</h3>
            <Link to="/">Privacy Policy</Link>
            <Link to="/">Termini di Servizio</Link>
            <Link to="/">Cookie Policy</Link>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 AI Agents Platform. Tutti i diritti riservati.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
